import React, { useEffect, useRef, useState } from 'react';
import { getPreferredImageSrc, rememberLoadedImageSrc } from '../../utils/imageSrcCache';

/**
 * Drop-in <img> that keeps showing the first unexpired URL for the same object
 * so remounts do not re-download when the API issues a new presigned GET.
 */
export function CachedImage({ src, alt = '', onLoad, onError, ...rest }) {
  const freshRef = useRef(src);
  const [current, setCurrent] = useState(() => getPreferredImageSrc(src));

  useEffect(() => {
    freshRef.current = src;
    setCurrent(getPreferredImageSrc(src));
  }, [src]);

  if (!current) return null;

  return (
    <img
      src={current}
      alt={alt}
      onLoad={(event) => {
        rememberLoadedImageSrc(current);
        if (onLoad) onLoad(event);
      }}
      onError={(event) => {
        if (current !== freshRef.current && freshRef.current) {
          setCurrent(freshRef.current);
          return;
        }
        if (onError) onError(event);
      }}
      {...rest}
    />
  );
}
